import React from "react";
import "./NoLoisResult.css";

const NoLoisResult = ({
    onFilterClick,
    legalCategories,
    currentPage = 1,
    onPageChange,
    loading = false,
}) => {
    // L'API retourne 20 résultats par page par défaut
    const itemsPerPage = 20;
    const totalPages = legalCategories.count
        ? Math.ceil(legalCategories.count / itemsPerPage)
        : 1;

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);

        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push("...");
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push("...");
            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <div className="no-lois-result-container">
            <div className="welcome-section">
                <h2>Bienvenue dans la recherche de textes de loi</h2>
                <p>
                    Explorez notre base de données juridique complète. Vous pouvez
                    rechercher par mot-clé, numéro d'article ou code spécifique.
                </p>
            </div>

            <div className="codes-section">
                <h3>Tous les codes de lois</h3>

                {loading ? (
                    <div className="loading-message">
                        <div className="loading-spinner"></div>
                        <p>Chargement des catégories...</p>
                    </div>
                ) : (
                    <>
                        <div className="categories-grid">
                            {legalCategories.results &&
                                legalCategories.results.map((category) => (
                                    <div key={category.id} className="category-card">
                                        <h4
                                            className="category-title"
                                            onClick={() => onFilterClick(category.title)}
                                        >
                                            {category.title}
                                        </h4>
                                        <div className="article-count">
                                            <span className="count-icon">📄</span>{" "}
                                            {category.total_articles} articles
                                        </div>
                                    </div>
                                ))}
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div className="pagination-container">
                                <button
                                    className="pagination-btn"
                                    disabled={!legalCategories.previous}
                                    onClick={() => onPageChange(currentPage - 1)}
                                >
                                    ← Précédent
                                </button>

                                <div className="pagination-numbers">
                                    {getPageNumbers().map((page, index) =>
                                        page === "..." ? (
                                            <span
                                                key={`ellipsis-${index}`}
                                                className="pagination-ellipsis"
                                            >
                                                ...
                                            </span>
                                        ) : (
                                            <button
                                                key={page}
                                                className={`pagination-number ${currentPage === page ? "active" : ""}`}
                                                onClick={() => onPageChange(page)}
                                            >
                                                {page}
                                            </button>
                                        )
                                    )}
                                </div>

                                <button
                                    className="pagination-btn"
                                    disabled={!legalCategories.next}
                                    onClick={() => onPageChange(currentPage + 1)}
                                >
                                    Suivant →
                                </button>
                            </div>
                        )}

                        {legalCategories.count > 0 && (
                            <div className="results-info">
                                {legalCategories.count} textes de loi au total — Page{" "}
                                {currentPage} sur {totalPages}
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className="search-tips">
                <h3>Conseils de recherche</h3>
                <ul>
                    <li>
                        Utilisez des termes précis pour obtenir des résultats pertinents
                    </li>
                    <li>Recherchez par numéro d'article (ex: "article 1134")</li>
                    <li>Spécifiez le code concerné (ex: "code civil")</li>
                    <li>Utilisez les filtres pour affiner votre recherche</li>
                </ul>
            </div>
        </div>
    );
};

export default NoLoisResult;